import { KeyPetPoliciesByName } from './petHelpers';
import { dateIsSameOrAfter, dateIsSameOrBefore } from '../utils/date';
import { revertLegacyPolicyNumberFormat } from './paymentHelper';

export const EnrichTransactionData = ({ petDetails, transactionsData = [] }) => {
  const petsKeyedByName = KeyPetPoliciesByName({ petDetails });

  return transactionsData.reduce((acc, transactionData) => {
    const updatedData = { ...transactionData, ...petsKeyedByName[transactionData.Pet] };
    acc.push(updatedData);
    return acc;
  }, []);
};

export const GetTransactionTypeOptions = ({ transactionsData = [] }) => {
  return [
    ...new Set(
      transactionsData.reduce(
        (acc, transactionData) => {
          const typeFilter = {
            label: transactionData.Type,
            value: transactionData.Type
          };

          if (JSON.stringify(acc).indexOf(JSON.stringify(typeFilter)) === -1) {
            acc.push(typeFilter);
          }
          return acc;
        },
        [{ label: 'All types', value: '' }]
      )
    )
  ];
};

/*
filterSettings = {
  policy: '' or policyNumber,
  fromDate: '' or date object,
  toDate: '' or date object,
}
 */

export const filterTransactions = ({ transactions, filterSettings }) => {
  const { policy, fromDate, toDate, type } = filterSettings;

  // Cater for receiving FullPolicyNumber instead of short version
  const policyAsNumber = policy ? revertLegacyPolicyNumberFormat(policy) : '';

  return transactions.filter((transaction) => {
    const policyMatch = !policy || policyAsNumber === transaction.FullPolicyNumber;
    const fromDateMatch = !fromDate || dateIsSameOrAfter(fromDate, transaction.Date);
    const toDateMatch = !toDate || dateIsSameOrBefore(toDate, transaction.Date);
    const typeMatch = !type || type === transaction.Type;

    return policyMatch && fromDateMatch && toDateMatch && typeMatch;
  });
};

export const sortTransactionsByDate = ({ transactions, descending = true }) => {
  const sortedDocs = transactions.sort((documentA, documentB) => {
    const dateA = new Date(documentA.Date);
    const dateB = new Date(documentB.Date);

    if (dateA.getTime() !== dateB.getTime()) {
      return dateB.getTime() - dateA.getTime();
    }

    // Dates are equal — sort by Pet name ascending
    const petA = (documentA.Pet || '').toLowerCase();
    const petB = (documentB.Pet || '').toLowerCase();

    return petB.localeCompare(petA);
  });

  return descending ? sortedDocs : sortedDocs.reverse();
};
